import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ItemArticle from '../../../../topics/Article/components/ItemArticle'
import AdUnit from '../../../../components/AdUnit'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: calc(-${(props) => props.theme.sizes.gapVertical} / 2);
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-bottom: calc(-${(props) => props.theme.tablet.sizes.gapVertical} / 2);
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-bottom: calc(-${(props) => props.theme.mobile.sizes.gapVertical} / 2);
  }
`

class BlockSingleLandscapeArticle extends PureComponent {
  render() {
    const {
      data: { articles, hideDefaults },
      adIds,
      ...props
    } = this.props
    console.log(hideDefaults)
    return (
      <Wrapper {...props}>
        {articles[0] && <ItemArticle view="small_landscape" article={articles[0]} hideDefaults={hideDefaults} />}
      </Wrapper>
    )
  }
}

BlockSingleLandscapeArticle.propTypes = {
  articles: PropTypes.arrayOf(ItemArticle.propTypes.article),
  adIds: PropTypes.arrayOf(AdUnit.propTypes.adId),
}

export default BlockSingleLandscapeArticle
export { Wrapper as Wrapper0BlockSingleLandscapeArticle }
